import { useRouter } from 'next/router'
import { signOut, useSession } from 'next-auth/react'
import { useTranslation } from 'next-i18next'
import LogOutIcon from 'assets/icons/nucleo/18px_rect-logout.svg'
import { NavigationItem } from 'components/Layout/Header/DisciplineContent/NavigationItem'
import { minWidthIcon } from 'components/Layout/Header/Header.style'

export const DisconnectButton = () => {
  const { t } = useTranslation('authentication')
  const router = useRouter()
  const session = useSession()

  if (session?.status !== 'authenticated') return null

  return (
    <NavigationItem
      leftIcon={<LogOutIcon css={minWidthIcon} />}
      text={t('signOut')}
      onClick={() =>
        signOut({
          callbackUrl: `/${
            router.locale === router.defaultLocale ? '' : router.locale
          }`
        })
      }
    />
  )
}
